import { render, staticRenderFns } from "./ActivityAgendaItem.vue?vue&type=template&id=5b4b6798&scoped=true&"
import script from "./ActivityAgendaItem.vue?vue&type=script&lang=js&"
export * from "./ActivityAgendaItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAgendaItem.vue?vue&type=style&index=0&id=5b4b6798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b6798",
  null
  
)

export default component.exports